import React from 'react';
import '../App.css';
import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

AOS.init();

export default class AboutUs extends React.Component {

    render() {
        const servicesData = [
            {
                title: "Residential Interiors",
                description: "Transform your home into a personal sanctuary with our thoughtful design approach. From compact apartments to luxury villas, we create warm, functional spaces that reflect your lifestyle with timeless aesthetics and flawless execution.",
                icon: "fa fa-home"
            },
            {
                title: "Commercial Interiors", 
                description: "Elevate your business with interiors that speak success. We design impactful retail stores, showrooms, and offices that align with your brand identity while maximizing customer experience and operational efficiency.",
                icon: "fa fa-building"
            },
            {
                title: "Custom Furniture & Turnkey Solutions",
                description: "From bespoke wardrobes to statement pieces, we craft furniture tailored to your space and taste. Our comprehensive turnkey service means you hand us the keys once and receive a fully transformed, move-in-ready space.",
                icon: "fa fa-cogs"
            },
            {
                title: "Complete Renovation & Technical Services",
                description: "We handle every aspect of your project - civil work, electrical installations, false ceilings, POP work, and complete renovations. Our expert team ensures seamless execution from foundation to finishing touches.",
                icon: "fa fa-wrench"
            }
        ];

        return (
            <div className="container aboutUs-custom-top container-sm" style={{marginTop: '50px'}}>
                <div id="#scrolly-div" className="row add-mobile-padding">
                    <div className="col-sm-6 col-md-6 mt-sm-5">
                        <div className="row mt-sm-5">
                            <div data-aos="fade-right" data-aos-duration="1000" className="col-2 col-sm-1">
                                <span><hr className="slash"></hr></span>
                            </div>
                            <div className="col-10 col-sm-11">
                                <p data-aos="fade-left" data-aos-duration="1000" className="about-topic">SERVICES</p>
                            </div>
                        </div>
                        <div className="row">
                            <p className="about-sub-topic">
                                <span style={{ color: '#2c3e50' }}>WHAT WE </span> 
                                <span style={{ color: '#cd853f' }}> OFFER</span>
                            </p>
                        </div>
                        <div className="row">
                            <div className="col-sm-8 col-md-12">
                                <p data-aos="fade-right" data-aos-duration="1000" data-aos-easing="ease-in-sine" className="about-text">
                                    At Shree Jeen Interiors, we transform spaces into stunning sanctuaries that reflect your unique style and functionality needs. With over 15 years of expertise, we deliver end-to-end interior solutions - from conceptual design to final execution. Whether you're dreaming of a cozy home makeover, a professional office space, or custom furniture pieces, we bring creativity, precision, and timeless elegance to every project across residential and commercial sectors.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Services Carousel */}
                    <div className="col-sm-6 col-md-6 mt-lg-5">
                        <div className="services-carousel-container" data-aos="fade-left" data-aos-duration="1000">
                            <Carousel
                                showArrows={true}
                                showStatus={false}
                                showThumbs={false}
                                infiniteLoop={true}
                                autoPlay={true}
                                interval={4000}
                                stopOnHover={true}
                                swipeable={true}
                                emulateTouch={true}
                                className="services-carousel"
                            >
                                {servicesData.map((service, index) => (
                                    <div key={index} className="service-slide">
                                        <div className="service-card">
                                            <div className="service-icon">
                                                <i className={service.icon}></i>
                                            </div>
                                            <h3 className="service-title">{service.title}</h3>
                                            <p className="service-description">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </Carousel>
                        </div>
                    </div>
                </div>

                {/* Add custom styles */}
                <style jsx>{`
                    .services-carousel-container {
                        padding: 20px;
                        height: auto;
                    }

                    .service-slide {
                        padding: 20px;
                        height: 400px;
                        display: flex !important;
                        align-items: center;
                        justify-content: center;
                    }

                    .service-card {
                        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
                        border-radius: 20px;
                        padding: 30px 25px;
                        text-align: center;
                        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
                        border: 2px solid #15d4c7;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        transition: all 0.3s ease;
                        max-width: 100%; /* Ensure card doesn't exceed container */
                        box-sizing: border-box; /* Include padding in width calculation */
                    }

                    .service-card:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 15px 40px rgba(21, 212, 199, 0.2);
                    }

                    .service-icon {
                        font-size: 48px;
                        color: #15d4c7;
                        margin-bottom: 20px;
                    }

                    .service-title {
                        font-size: 20px;
                        font-weight: 700;
                        color: #2c3e50;
                        margin-bottom: 15px;
                        line-height: 1.3;
                        word-wrap: break-word; /* Allow long titles to wrap */
                    }

                    .service-description {
                        font-size: 14px;
                        color: #666;
                        line-height: 1.6;
                        margin: 0;
                        word-wrap: break-word; /* Allow long text to wrap */
                    }

                    .services-carousel .carousel .control-arrow {
                        background: #15d4c7 !important;
                        opacity: 0.8;
                        border-radius: 50%;
                        width: 40px;
                        height: 40px;
                        top: 50%;
                        transform: translateY(-50%);
                    }

                    .services-carousel .carousel .control-arrow:hover {
                        opacity: 1;
                        background: #0aa79d !important;
                    }

                    .services-carousel .carousel .control-dots {
                        margin: 20px 0 0 0;
                    }

                    .services-carousel .carousel .control-dots .dot {
                        background: #15d4c7 !important;
                        box-shadow: none;
                        width: 12px;
                        height: 12px;
                        border-radius: 50%;
                        margin: 0 6px;
                    }

                    .services-carousel .carousel .control-dots .dot.selected {
                        background: #2c3e50 !important;
                    }

                    /* Mobile Responsiveness */
                    @media (max-width: 768px) {
                        .services-carousel-container {
                            padding: 10px 5px; /* Reduced padding for more width */
                            width: 100%;
                            max-width: 100%;
                            box-sizing: border-box;
                        }

                        .service-slide {
                            height: 380px; /* Increased height for better content fit */
                            padding: 10px; /* Reduced padding */
                            width: 100%;
                            max-width: 100%;
                        }

                        .service-card {
                            padding: 25px 20px; /* Adjusted padding */
                            max-width: 100%;
                            width: 100%;
                            box-sizing: border-box;
                            margin: 0 auto;
                        }

                        .service-icon {
                            font-size: 32px; /* Slightly smaller icon */
                            margin-bottom: 15px;
                        }

                        .service-title {
                            font-size: 16px; /* Reduced font size */
                            margin-bottom: 12px;
                            line-height: 1.2;
                        }

                        .service-description {
                            font-size: 12px; /* Reduced font size for better fit */
                            line-height: 1.5;
                        }
                    }

                    /* Extra small screens (phones in portrait) */
                    @media (max-width: 480px) {
                        .services-carousel-container {
                            padding: 5px 2px; /* Minimal padding */
                            margin: 0;
                        }

                        .service-slide {
                            height: 350px;
                            padding: 5px; /* Minimal padding */
                        }

                        .service-card {
                            padding: 20px 15px; /* More compact padding */
                            border-radius: 15px; /* Smaller border radius */
                        }

                        .service-icon {
                            font-size: 28px; /* Smaller icon */
                            margin-bottom: 12px;
                        }

                        .service-title {
                            font-size: 15px; /* Smaller title */
                            margin-bottom: 10px;
                        }

                        .service-description {
                            font-size: 11px; /* Smaller text */
                            line-height: 1.4;
                        }
                    }

                    /* Very small screens */
                    @media (max-width: 360px) {
                        .services-carousel-container {
                            padding: 2px 0; /* Minimal padding */
                        }

                        .service-slide {
                            height: 320px; /* Reduced height */
                            padding: 2px;
                        }

                        .service-card {
                            padding: 15px 12px; /* Very compact */
                        }

                        .service-icon {
                            font-size: 24px;
                            margin-bottom: 10px;
                        }

                        .service-title {
                            font-size: 14px;
                            margin-bottom: 8px;
                        }

                        .service-description {
                            font-size: 10px;
                        }
                    }
                `}</style>
            </div >
        )
    };
};



